import { IsNumber, IsString, ValidateNested, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { RgbaDto } from './RgbaDto';
import { GradientDto } from './GradientDto';
import { TypographySizeDto } from './TypographySizeDto';
import { IsColorOrReference } from './validators/IsColorOrReference';

export class HeadingLevelDto {
  @IsDefined()
  @IsNumber()
  letterSpacing!: number;

  @IsDefined()
  @IsString()
  fontWeight!: string;

  @IsDefined()
  @IsNumber()
  lineHeight!: number;

  @IsDefined()
  @IsColorOrReference()
  fontColor!: RgbaDto | GradientDto | string;

  @IsColorOrReference()
  backgroundColor!: RgbaDto | GradientDto | string | null;

  @IsDefined()
  @ValidateNested()
  @Type(() => TypographySizeDto)
  desktop!: TypographySizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => TypographySizeDto)
  tablet!: TypographySizeDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => TypographySizeDto)
  mobile!: TypographySizeDto;
}
